﻿class ELEAccordion extends HTMLElement {    
    constructor() {
        super();
        this.accordionHead = this.querySelector('[data-accordion-head]') || undefined;
        this.accordionBody = this.querySelector('[data-accordion-body]') || undefined;
        this.activeClassName = this.getAttribute('data-accordion-active-class-name') || 'accordion--active'
    }

    connectedCallback() {
        if (!this.accordionHead || !this.accordionBody) return;
        this.registerListener();
    }

    registerListener() {
        this.toggleBodyFunction = this.toggleBody.bind(this);
        this.accordionHead.addEventListener('click', this.toggleBodyFunction);
    }

    toggleBody() {
        this.classList.toggle(this.activeClassName);
    }

    disable() {
        this.classList.add('accordion--no-icon');
        this.accordionHead.removeEventListener('click', this.toggleBodyFunction);
    }
    
    enable() {
        this.disable(); // remove eventlistener
        this.classList.remove('accordion--no-icon');
        this.registerListener();
    }
}

customElements.define('ele-accordion', ELEAccordion);